<template>
    <div class="uk-container uk-container-expand">
        <div class="uk-margin-remove-right uk-margin-medium-top">
            <span class="uk-form-label">Records Per Page</span>
            <select class="uk-select" v-model="perPage" style="width:5em;">
                <option v-for="val in recordOptions" :value="val" >{{val}}</option>
            </select>
            <ul class="uk-tab" uk-switcher="animation: uk-animation-fade">
                <li class="uk-active"><a href="#certs">Current Placements</a></li>
                <li><a href="#train">Upcoming Placements</a></li>
                <li><a href="#users">Work History</a></li>
                <li><a href="#other">Ratings</a></li>
            </ul>
            <ul class="uk-switcher">
                <li class="uk-container uk-align-left uk-width-1-1">
                    <data-table
                        ref="currentPlacements"
                        :searchable="false"
                        :api_point="'employee/' + pid + '/current-placements'"
                        :per_page=perPage
                        :table_headers="{'requisition.number':{display:'Requisition Number',sortable: false,route:'/requisitions/view/{requisition_id}',target:'_blank'},
							'requisition.name':{display:'Requisition Name',sortable: false},
							'requisition.customer':{display:'Customer Name',sortable: false},
							'requisition.manager_name':{display:'Field Manager',sortable: false},
							'date_range':{display:'Requisition Date',sortable: false},
							'skill.name':{display:'Craft', sortable: false},
							'requisition.businessUnit.name':{display:'Business Unit', sortable: false},
							'payCode.code':{display:'Craft Code',sortable: false},
							'id':{display:'', sortable:false, buttons:[
								{
									faClass:'fas fa-star', event:'rate'
								}
							]}
						}"
						@rate="startRating"
                    ></data-table>
                </li>
                <li class="uk-container uk-align-left uk-width-1-1">
                    <data-table
                        ref="futurePlacements"
                        :searchable="false"
                        :api_point="'employee/' + pid + '/future-placements'"
                        :per_page=perPage
                        :table_headers="{'requisition.number':{display:'Requisition Number',sortable: false,route:'/requisitions/view/{requisition_id}',target:'_blank'},
							'requisition.name':{display:'Requisition Name',sortable: false},
							'requisition.customer':{display:'Customer Name',sortable: false},
							'requisition.manager_name':{display:'Field Manager',sortable: false},
							'date_range':{display:'Requisition Date',sortable: false},
							'skill.name':{display:'Craft', sortable: false},
							'requisition.businessUnit.name':{display:'Business Unit', sortable: false},
							'payCode.code':{display:'Craft Code',sortable: false}
						}"
                    ></data-table>
                </li>
                <li class="uk-container uk-align-left uk-width-1-1">
                    <data-table
                        ref="pastPlacements"
                        :searchable="false"
                        :api_point="'employee/' + pid + '/past-placements'"
                        :per_page="perPage"
                        :table_headers="{'requisition.number':{display:'Requisition Number',sortable: false,route:'/requisitions/view/{requisition_id}',target:'_blank'},
							'requisition.name':{display:'Requisition Name',sortable: false},
							'requisition.customer':{display:'Customer Name',sortable: false},
							'requisition.manager_name':{display:'Field Manager',sortable: false},
							'date_range':{display:'Requisition Date',sortable: false},
							'skill.name':{display:'Craft', sortable: false},
							'requisition.businessUnit.name':{display:'Business Unit', sortable: false},
							'payCode.code':{display:'Craft Code',sortable: false},
							average_rating: {display:'Rating', sortable: false},
							'id':{display:'', sortable:false, buttons:[
								{
									faClass:'fas fa-star', event:'rate'
								}
							]}
						}"
						@rate="startRating"
                    ></data-table>
                </li>
                <li class="uk-container uk-align-left uk-width-3-4@xl">
                    <employee-ratings ref="employeeRatings" :pid="pid"></employee-ratings>
                </li>
            </ul>
        </div>

		<div id="ratingModal" uk-modal>
			<rating-form ref="ratingForm" table="currentPlacements" @complete="closeForm"></rating-form>
		</div>
    </div>
</template>

<script>
    import EmployeeRatings from "./EmployeeRatings";
	import RatingForm from "./ModalForms/RatingForm.vue";
    export default {
        name: "EmployeePlacementData",

        components:{
			RatingForm,
            EmployeeRatings
        },

        props: {
            pid:{type:Number}
        },

        data() {
            return {
                perPage: 30,
                recordOptions: [10,15,30,50]
            };
        },

        methods: {
            startSearch(){
                this.$refs.currentPlacements.startSearch();
                this.$refs.futurePlacements.startSearch();
                this.$refs.pastPlacements.startSearch();
            },
			startRating(id){
				this.$refs.ratingForm.loadForm(id);
				UIkit.modal("#ratingModal").show();
			},
			closeForm(){
				UIkit.modal("#ratingModal").hide();
				setTimeout(() => this.startSearch(), 500);
			}
        },

        watch:{
            perPage() {
                setTimeout(() => this.startSearch(), 5);
            },
        }
    }
</script>

<style scoped>

</style>
